module.exports = __webpack_public_path__ + "a4bd2053681b70cbd5041e61dbbcf829.jpg";